(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tanzy-five-mode"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('tanzy-five-mode')) {
customElements.define('tanzy-five-mode', class extends HTMLElement {
connectedCallback() {
if (this.initialized) return;
this.initialized = true;
const select = this.querySelector('[data-five-select]');
if (!select) return;
const update = changeUrl => {
const option = select.selectedOptions[0];
if (!option) return;
this.querySelector('[data-five-price]').textContent = option.dataset.price;
const button = this.querySelector('[data-five-buy]');
button.disabled = option.dataset.available !== 'true';
button.textContent = button.disabled ? button.dataset.soldOut : button.dataset.label;
const image = this.querySelector('.tm-main-image');
if (image && option.dataset.image) {
image.removeAttribute('srcset'); image.removeAttribute('sizes');
image.src = option.dataset.image; image.alt = option.dataset.alt;
}
if (changeUrl && location.pathname === this.dataset.productUrl) {
const next = new URL(location.href); next.searchParams.set('variant', option.value);
history.replaceState({}, '', next);
}
};
update(false); select.addEventListener('change', () => update(true));
}
});
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tanzy-shower-edit"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tanzy-shower-page')) {
  customElements.define('tanzy-shower-page', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const update = (select, changeUrl) => {
        const option = select.selectedOptions[0];
        if (!option) return;
        const group = select.closest('[data-purchase]');
        let shownPrice = option.dataset.price;
        const planBox = group.querySelector('[data-plan-box]');
        if (planBox) {
          const hasPlan = !!option.dataset.plan;
          planBox.hidden = !hasPlan;
          const planInput = planBox.querySelector('[data-plan-input]');
          const subRadio = planBox.querySelector('[data-plan-sub]');
          planBox.querySelector('[data-once-price]').textContent = option.dataset.price;
          if (hasPlan) {
            planBox.querySelector('[data-plan-price]').textContent = option.dataset.planPrice;
            planBox.querySelector('[data-plan-label]').textContent = option.dataset.planLabel;
            planInput.value = option.dataset.plan;
          }
          const subscribing = hasPlan && subRadio.checked;
          planInput.disabled = !subscribing;
          if (subscribing) shownPrice = option.dataset.planPrice;
        }
        group.querySelector('[data-variant-price]').textContent = shownPrice;
        const button = group.querySelector('[data-buy-button]');
        button.disabled = option.dataset.available !== 'true';
        button.textContent = button.disabled ? button.dataset.soldOut : button.dataset.label;
        const image = this.querySelector(group.dataset.purchase === 'head' ? '.ts-main-image' : '.ts-extra-image');
        if (image && option.dataset.image) {
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.src = option.dataset.image;
          image.alt = option.dataset.alt;
        }
        if (group.dataset.purchase === 'head') {
          this.querySelectorAll('[data-pick]').forEach(link => {
            if (link.dataset.pick === option.value) link.setAttribute('aria-current', 'true');
            else link.removeAttribute('aria-current');
          });
        }
        if (changeUrl && location.pathname === this.dataset.productUrl) {
          const next = new URL(location.href);
          next.searchParams.set('variant', option.value);
          history.replaceState({}, '', next);
        }
      };
      this.querySelectorAll('[data-variant-select]').forEach(select => {
        update(select, false);
        select.addEventListener('change', () => update(select, true));
        const group = select.closest('[data-purchase]');
        group.querySelectorAll('[data-plan-once],[data-plan-sub]').forEach(radio => radio.addEventListener('change', () => update(select, false)));
      });
      this.querySelectorAll('[data-pick]').forEach(link => {
        link.addEventListener('click', event => {
          const select = this.querySelector('[data-purchase="head"] [data-variant-select]');
          const option = Array.from(select.options).find(o => o.value === link.dataset.pick);
          if (!option || option.disabled) return;
          event.preventDefault();
          select.value = link.dataset.pick;
          update(select, true);
          this.querySelector('#shop-showerhead').scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
          select.focus({preventScroll:true});
        });
      });
    }
  });
}

if (!customElements.get('tanzy-five-mode')) {
customElements.define('tanzy-five-mode', class extends HTMLElement {
connectedCallback() {
if (this.initialized) return;
this.initialized = true;
const select = this.querySelector('[data-five-select]');
if (!select) return;
const update = changeUrl => {
const option = select.selectedOptions[0];
if (!option) return;
this.querySelector('[data-five-price]').textContent = option.dataset.price;
const button = this.querySelector('[data-five-buy]');
button.disabled = option.dataset.available !== 'true';
button.textContent = button.disabled ? button.dataset.soldOut : button.dataset.label;
const image = this.querySelector('.tm-main-image');
if (image && option.dataset.image) {
image.removeAttribute('srcset'); image.removeAttribute('sizes');
image.src = option.dataset.image; image.alt = option.dataset.alt;
}
if (changeUrl && location.pathname === this.dataset.productUrl) {
const next = new URL(location.href); next.searchParams.set('variant', option.value);
history.replaceState({}, '', next);
}
};
update(false); select.addEventListener('change', () => update(true));
}
});
}


  } catch(e) { console.error(e); }
})();
})();
